<template>
  <div>
    <!-- <div v-if="outRounterView.indexOf(this.$route.path) != -1">
      <LoginPage></LoginPage>
    </div>
    <div v-else-if="kubotaPage.indexOf(this.$route.path) != -1">
      <kubotafarmOverview />
    </div>
    <div v-else-if="this.$route.path.includes('PublicAjinomoto')">
      <router-view :key="$route.path"></router-view>
    </div>
    <div v-else-if="['/loginnew'].indexOf(this.$route.path) != -1">
      <loginnew />
    </div>
    <router-view v-else></router-view> -->
    <component :is="Layout">
      <router-view></router-view>
      <!-- <router-view :key="$route.fullPath"></router-view> -->
    </component>
  </div>
</template>

<script>
// import FingerprintJS from "@fingerprintjs/fingerprintjs";
// import LoginPage from "./views/view-componentsSentenance/Login/LoginPage.vue";
// import kubotafarmOverview from "./views/components/dashboard/kubota/dashboard/allplant.vue";
// import loginnew from "./views/components/dashboard/kubota/loginnew.vue";
// import Ajinomoto from "./views/components/dashboard/Ajinomoto/public/routeroverview.vue";

import MainContainer from "@/layout/full/MainContainer.vue";
import LayoutBlank from "@/layout/blank/LayoutBlank.vue";
import LayoutNavbar from "@/layout/navbar/LayoutNavbar.vue";
import LayoutKubota from "@/layout/kubota/LayoutKubota.vue";

export default {
  components: {
    // LoginPage,
    // kubotafarmOverview,
    // loginnew,
    // Ajinomoto,
    MainContainer,
    LayoutBlank,
    LayoutNavbar,
    LayoutKubota,
  },
  name: "app",
  data: () => ({
    // outRounterView: ["/login", "/reset", "/Resetpassword", "/register"],
    // kubotaPage: [
    //   "/kubotafarmOverview",
    //   "/kubotafarmSolar",
    //   "/kubotafarmRice",
    //   "/kubotafarmPlant3",
    //   "/kubotafarmPlant4",
    //   "/kubotafarmPlant5",
    //   "/kubotafarmPlant6",
    //   "/kubotafarmPlant7",
    //   "/kubotafarmPlant8",
    // ],
  }),
  computed: {
    Layout() {
      console.log("layout", this.$route.meta.layout);
      // if (this.$route.meta.layout === undefined) return 'layout-blank'
      if (this.$route.meta.layout === "blank") return "layout-blank";
      if (this.$route.meta.layout === "content") return "main-container";
      if (this.$route.meta.layout === "navbar") return "layout-navbar";
      if (this.$route.meta.layout === "kubota") return "layout-kubota";

      return "main-container";
      // return "layout-blank";
    },
  },

  methods: {
    push(
      accessToken,
      refreshToken,
      token,
      username,
      pack,
      perm,
      mode,
      admin,
      ischeckform
    ) {
      this.$session.set("accessToken", accessToken);
      this.$session.set("refreshToken", refreshToken);
      this.$session.set("token", token);
      this.$session.set("username", username);
      this.$session.set("package", pack);
      this.$session.set("controlperm", perm);
      this.$session.set("role", mode);
      this.$session.set("ischeckform", ischeckform);

      console.log(username, admin);

      if (admin) this.$session.set("admin", admin);

      this.$API
        .post("checkin", {
          username: this.$session.get("username"),
        })
        .catch((err) => {
          console.log(err);
        });

      this.activeLoading = true;
      this.$vs.loading({
        type: "default",
      });
      
      setTimeout(() => {
        this.activeLoading = false;
        this.$vs.loading.close();
        var fullpath = this.$session.get("path");
        console.log('Full Path', fullpath, username, admin)
        if (fullpath) this.$router.push({ path: fullpath.fullPath });
        else if (
          username == "pttdemo" ||
          username == "camilliandemo" ||
          username == "spartan"
        )
          this.$router.push({ path: "/IndoorOverview" });
        else if (username == "betagrodemo" || admin == "betagrodemo")
          this.$router.push({ path: "/IndoorDashboard" });
        else if (username == "warehousedemo")
          this.$router.push({ path: "/warehouse" });
        else if (username == "Rivacold01" || admin == "Rivacold01")
          this.$router.push({ path: "/IndoorOverview" });
        else if (username == "syntecdemo")
          this.$router.push({ path: "/IndoorOverview" });
        else if (username == "unicorndemo")
          this.$router.push({ path: "/IndoorOverview" });
        else if (username == "frasers.kho")
          this.$router.push({ path: "/mapOverview" });
        else if (username == "birchteladmin" || admin == "birchteladmin")
          this.$router.push({ path: "/dashboard/sriboonrueng" });
        else if (username == "awcdemo" || admin == "awcdemo")
          this.$router.push({ path: "/asset-world/overview" });
        else this.$router.push({ path: "/overview" });
      }, 1000);
    },
  },
  async created() {
    console.log(this.$session.get("path"));
    console.log(process.env);
    // await FingerprintJS.load().then((fp) => {
    //   // The FingerprintJS agent is ready.
    //   // Get a visitor identifier when you'd like to.
    //   fp.get().then((result) => {
    //     this.$http
    //       .post(this.$url2 + "rememberme", {
    //         headers: {
    //           "Access-Control-Request-Method": "*",
    //           "Access-Control-Request-Headers": "*",
    //           Origin: "*",
    //         },
    //         fingerprint: result.visitorId,
    //       })
    //       .then((result) => {
    //         if (result.status == 200) {
    //           let data = result.data; ิ 
    //           if (data.user.admin) {
    //             let user = data.user;
    //             this.push(
    //               data.accessToken,
    //               data.refreshToken,
    //               user.token,
    //               user.username,
    //               user.package,
    //               user.controlperm,
    //               "user",
    //               user.admin,
    //               user.ischeckform
    //             );
    //           } else {
    //             console.log("case 2");
    //             let user = data.user;
    //             this.push(
    //               data.accessToken,
    //               data.refreshToken,
    //               user.token,
    //               user.username,
    //               user.package,
    //               null,
    //               "admin",
    //               user.username,
    //               user.ischeckform
    //             );
    //           }
    //         }
    //       });
    //   });
    // });
  },
};
</script>

<style>
/* @import "/dhx-suite/codebase/suite.min.css"; */

#buttonfg {
  color: #4bb543;
  cursor: pointer;
}
#buttonfg:hover {
  color: black;
  cursor: pointer;
}
div.a {
  text-align: center;
}
@import "./index.css";
.cardBorder {
  border-radius: 20px;
}
</style>

